// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16NU7","right":"Footer_right__1CzRm","buttons":"Footer_buttons__2_Jae"};